import { useCallback } from 'react';

import { Icon } from '@rbilabs/universal-components';

import { Typography } from 'components/ui';
import { ModalCb } from 'hooks/use-error-modal';
import { t } from 'state/intl/translations';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { isNative } from 'utils/environment';
import { IErrorDialog, getPspRefusedErrorDialog, parseGraphQLErrorCodes } from 'utils/errors';
import { PspRefusedCodes } from 'utils/errors/types';

import { PspErrorIconBox, PspErrorTitleBox } from './styled';

export interface IHandlePspRefusedErrorInput {
  openErrorDialog: ModalCb;
}

export const useHandlePspRefusedError = ({ openErrorDialog }: IHandlePspRefusedErrorInput) => {
  const { loyaltyUser } = useLoyaltyUser();

  const handlePspRefusedError = useCallback(
    (error: any, isCashAppError: any) => {
      const errorCode = parseGraphQLErrorCodes(error)[0]?.extensions?.responseMessage;

      if (errorCode in PspRefusedCodes || isCashAppError) {
        const errorDialog: IErrorDialog | undefined = getPspRefusedErrorDialog(errorCode);

        const body = (
          <>
            <PspErrorIconBox $isNative={isNative}>
              <Icon alignSelf="center" variant="errorFill" size="10" />
            </PspErrorIconBox>
            <PspErrorTitleBox $isNative={isNative}>
              <Typography fontSize="xl" style={{ fontFamily: 'Flame-Regular' }}>
                {!isCashAppError && errorDialog?.title}
                {isCashAppError && t('pspPaymentDeclinedTransactionForterTitle')}
              </Typography>
            </PspErrorTitleBox>
            <Typography mt="$4">
              {!isCashAppError && errorDialog?.message.replace('{name}', loyaltyUser?.name || '')}
              {isCashAppError &&
                t('pspPaymentDeclinedTransactionForterMessage', { name: loyaltyUser?.name || '' })}
            </Typography>
          </>
        );

        if (errorDialog || isCashAppError) {
          openErrorDialog({
            title: undefined,
            body,
            isPspError: true,
          });
        }
      }
    },
    [loyaltyUser?.name, openErrorDialog]
  );

  return { handlePspRefusedError };
};
